import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import goTo from "vuetify/es5/services/goto";

//Middlewares
import Auth from './middleware/Auth';

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect: "/guest",
  },
  {
    path: '/guest',
    component: () => import(/* webpackChunkName: "LayoutGuest" */ '../views/layouts/LayoutGuest.vue'),
    children: [
      {
        path: '/guest',
        redirect: "/guest/login",
      },
      {
        path: '/guest/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
      },
      {
        path: '/guest/forgot-password',
        name: 'ForgotPassword',
        component: () => import(/* webpackChunkName: "ForgotPassword" */ '../views/ForgotPassword.vue')
      },
      {
        path: '/guest/reset-password',
        name: 'ResetPassword',
        component: () => import(/* webpackChunkName: "ResetPassword" */ '../views/ResetPassword.vue')
      },
      {
        path: "*",
        component: () => import("@/views/NotFound.vue"),
      }
    ],
  },
  {
    path: '/app',
    component: () => import(/* webpackChunkName: "LayoutAuth" */ '../views/layouts/LayoutAuth.vue'),
    children: [
      {
        path: '/app',
        redirect: "/app/home",
      },
      {
        path: '/app/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "Home" */ '../views/home/Index.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "Profile" */ '../views/profile/Profile.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/notificacoes',
        name: 'NotificacoesIndex',
        component: () => import(/* webpackChunkName: "NotificacoesIndex" */ '../views/notificacoes/NotificacoesIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/atendimentos',
        name: 'AtendimentosIndex',
        component: () => import(/* webpackChunkName: "AtendimentosIndex" */ '../views/atendimentos/AtendimentosIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/prontuarios',
        name: 'ProntuariosIndex',
        component: () => import(/* webpackChunkName: "ProntuariosIndex" */ '../views/prontuarios/ProntuariosIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/prontuarios-aptidao',
        name: 'ProntuariosAptidaoIndex',
        component: () => import(/* webpackChunkName: "ProntuariosAptidaoIndex" */ '../views/prontuarios/ProntuariosAptidaoIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/prontuarios/:prontuario',
        name: 'ProntuariosShow',
        component: () => import(/* webpackChunkName: "ProntuariosShow" */ '../views/prontuarios/ProntuariosShow.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/atendimentos-alta',
        name: 'AtendimentosAltaIndex',
        component: () => import(/* webpackChunkName: "AtendimentosAltaIndex" */ '../views/atendimentos/AtendimentosAltaIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/atendimentos-aptidao',
        name: 'AtendimentosAptidaoIndex',
        component: () => import(/* webpackChunkName: "AtendimentosAptidaoIndex" */ '../views/atendimentos_aptidao/AtendimentosAptidaoIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/atendimentos-aptidao/:atendimento/preencher',
        name: 'AtendimentoAptidaoCreate',
        component: () => import(/* webpackChunkName: "AtendimentoAptidaoCreate" */ '../views/atendimentos_aptidao/AtendimentoAptidaoCreate.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/atendimentos/create',
        name: 'AtendimentosCreate',
        component: () => import(/* webpackChunkName: "AtendimentosCreate" */ '../views/atendimentos/AtendimentosCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/atendimentos/:atendimento/edit',
        name: 'AtendimentosEdit',
        component: () => import(/* webpackChunkName: "AtendimentosEdit" */ '../views/atendimentos/AtendimentosEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/atendimentos/:atendimento',
        name: 'AtendimentosShow',
        component: () => import(/* webpackChunkName: "AtendimentosShow" */ '../views/atendimentos/AtendimentosShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/pacientes',
        name: 'PacientesIndex',
        component: () => import(/* webpackChunkName: "PacientesIndex" */ '../views/pacientes/PacientesIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/pacientes/create',
        name: 'PacientesCreate',
        component: () => import(/* webpackChunkName: "PacientesCreate" */ '../views/pacientes/PacientesCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/pacientes/:paciente/overview',
        name: 'PacientesOverview',
        component: () => import(/* webpackChunkName: "PacientesOverview" */ '../views/pacientes/PacientesOverview.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/pacientes/:paciente/registro-visita',
        name: 'PacientesRegistroVisitaCreate',
        component: () => import(/* webpackChunkName: "PacientesRegistroVisitaCreate" */ '../views/pacientes/PacientesRegistroVisitaCreate.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/pacientes/:paciente/edit',
        name: 'PacientesEdit',
        component: () => import(/* webpackChunkName: "PacientesEdit" */ '../views/pacientes/PacientesEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/pacientes/:paciente',
        name: 'PacientesShow',
        component: () => import(/* webpackChunkName: "PacientesShow" */ '../views/pacientes/PacientesShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/operadoras',
        name: 'OperadorasIndex',
        component: () => import(/* webpackChunkName: "OperadorasIndex" */ '../views/operadoras/OperadorasIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/operadoras/create',
        name: 'OperadorasCreate',
        component: () => import(/* webpackChunkName: "OperadorasCreate" */ '../views/operadoras/OperadorasCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/operadoras/:operadora/edit',
        name: 'OperadorasEdit',
        component: () => import(/* webpackChunkName: "OperadorasEdit" */ '../views/operadoras/OperadorasEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/operadoras/:operadora',
        name: 'OperadorasShow',
        component: () => import(/* webpackChunkName: "OperadorasShow" */ '../views/operadoras/OperadorasShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/plano-operadoras',
        name: 'PlanosOperadoraIndex',
        component: () => import(/* webpackChunkName: "PlanosOperadoraIndex" */ '../views/plano_operadoras/PlanosOperadoraIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/plano-operadoras/create',
        name: 'PlanosOperadoraCreate',
        component: () => import(/* webpackChunkName: "PlanosOperadoraCreate" */ '../views/plano_operadoras/PlanosOperadoraCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/plano-operadoras/:planoOperadora/edit',
        name: 'PlanosOperadoraEdit',
        component: () => import(/* webpackChunkName: "PlanosOperadoraEdit" */ '../views/plano_operadoras/PlanosOperadoraEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/plano-operadoras/:planoOperadora',
        name: 'PlanosOperadoraShow',
        component: () => import(/* webpackChunkName: "PlanosOperadoraShow" */ '../views/plano_operadoras/PlanosOperadoraShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/paciente-convenios',
        name: 'PacienteConveniosIndex',
        component: () => import(/* webpackChunkName: "PacienteConveniosIndex" */ '../views/paciente_convenios/PacienteConveniosIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/paciente-convenios/create',
        name: 'PacienteConveniosCreate',
        component: () => import(/* webpackChunkName: "PacienteConveniosCreate" */ '../views/paciente_convenios/PacienteConveniosCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/paciente-convenios/:pacienteConvenio/edit',
        name: 'PacienteConveniosEdit',
        component: () => import(/* webpackChunkName: "PacienteConveniosEdit" */ '../views/paciente_convenios/PacienteConveniosEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/paciente-convenios/:pacienteConvenio',
        name: 'PacienteConveniosShow',
        component: () => import(/* webpackChunkName: "PacienteConveniosShow" */ '../views/paciente_convenios/PacienteConveniosShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/terminologias',
        name: 'TerminologiasIndex',
        component: () => import('../views/terminologias/TerminologiasIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/terminologias/create',
        name: 'TerminologiasCreate',
        component: () => import('../views/terminologias/TerminologiasPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/terminologias/:terminologia/edit',
        name: 'TerminologiasEdit',
        component: () => import('../views/terminologias/TerminologiasPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/terminologias/:terminologia',
        name: 'TerminologiasShow',
        component: () => import('../views/terminologias/TerminologiasPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/tuss',
        name: 'TussIndex',
        component: () => import('../views/tuss/TussIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/tuss/create',
        name: 'TussCreate',
        component: () => import('../views/tuss/TussPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/tuss/:tuss/edit',
        name: 'TussEdit',
        component: () => import('../views/tuss/TussPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/tuss/:tuss',
        name: 'TussShow',
        component: () => import('../views/tuss/TussPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/fator-cobrancas',
        name: 'FatorCobrancasIndex',
        component: () => import('../views/fator_cobrancas/FatorCobrancasIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/fator-cobrancas/create',
        name: 'FatorCobrancasCreate',
        component: () => import('../views/fator_cobrancas/FatorCobrancasPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/fator-cobrancas/:fatorCobranca/edit',
        name: 'FatorCobrancasEdit',
        component: () => import('../views/fator_cobrancas/FatorCobrancasPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/fator-cobrancas/:fatorCobranca',
        name: 'FatorCobrancasShow',
        component: () => import('../views/fator_cobrancas/FatorCobrancasPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/tuss-convenio-precos',
        name: 'TussConvenioPrecosIndex',
        component: () => import('../views/tuss_convenio_precos/TussConvenioPrecosIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/tuss-convenio-precos/create',
        name: 'TussConvenioPrecosCreate',
        component: () => import('../views/tuss_convenio_precos/TussConvenioPrecosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/tuss-convenio-precos/:tussConvenioPreco/edit',
        name: 'TussConvenioPrecosEdit',
        component: () => import('../views/tuss_convenio_precos/TussConvenioPrecosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/tuss-convenio-precos/:tussConvenioPreco',
        name: 'TussConvenioPrecosShow',
        component: () => import('../views/tuss_convenio_precos/TussConvenioPrecosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/regra-faturamentos',
        name: 'RegraFaturamentosIndex',
        component: () => import('../views/regra_faturamentos/RegraFaturamentosIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/regra-faturamentos/create',
        name: 'RegraFaturamentosCreate',
        component: () => import('../views/regra_faturamentos/RegraFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/regra-faturamentos/:regraFaturamento/edit',
        name: 'RegraFaturamentosEdit',
        component: () => import('../views/regra_faturamentos/RegraFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/regra-faturamentos/:regraFaturamento',
        name: 'RegraFaturamentosShow',
        component: () => import('../views/regra_faturamentos/RegraFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/guia-autorizacoes',
        name: 'GuiaAutorizacoesIndex',
        component: () => import('../views/guia_autorizacoes/GuiaAutorizacoesIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/guia-autorizacoes/create',
        name: 'GuiaAutorizacoesCreate',
        component: () => import('../views/guia_autorizacoes/GuiaAutorizacoesPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/guia-autorizacoes/:guiaAutorizacao/edit',
        name: 'GuiaAutorizacoesEdit',
        component: () => import('../views/guia_autorizacoes/GuiaAutorizacoesPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/guia-autorizacoes/:guiaAutorizacao',
        name: 'GuiaAutorizacoesShow',
        component: () => import('../views/guia_autorizacoes/GuiaAutorizacoesPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/configuracao-faturamento',
        name: 'ConfiguracaoFaturamento',
        component: () => import('../views/configuracao_faturamento/ConfiguracaoFaturamentoPage.vue'),
        meta: { middleware: Auth },
      },
      {
        path: '/app/lancamento-faturamentos',
        name: 'LancamentoFaturamentosIndex',
        component: () => import('../views/lancamento_faturamentos/LancamentoFaturamentosIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/contas-faturamento/:contaFaturamento',
        name: 'ContaFaturamentoShow',
        component: () => import('../views/lancamento_faturamentos/ContaFaturamentoShow.vue'),
        meta: { middleware: Auth },
      },
      {
        path: '/app/contas-faturamento/paciente/:paciente/historico',
        name: 'ContaFaturamentoHistoricoPaciente',
        component: () => import('../views/lancamento_faturamentos/ContaFaturamentoHistoricoPaciente.vue'),
        meta: { middleware: Auth },
      },
      {
        path: '/app/lancamento-faturamentos/create',
        name: 'LancamentoFaturamentosCreate',
        component: () => import('../views/lancamento_faturamentos/LancamentoFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/lancamento-faturamentos/:lancamentoFaturamento/edit',
        name: 'LancamentoFaturamentosEdit',
        component: () => import('../views/lancamento_faturamentos/LancamentoFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/lancamento-faturamentos/:lancamentoFaturamento',
        name: 'LancamentoFaturamentosShow',
        component: () => import('../views/lancamento_faturamentos/LancamentoFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/lote-faturamentos',
        name: 'LoteFaturamentosIndex',
        component: () => import('../views/lote_faturamentos/LoteFaturamentosIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/lote-faturamentos/create',
        name: 'LoteFaturamentosCreate',
        component: () => import('../views/lote_faturamentos/LoteFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'create',
        },
      },
      {
        path: '/app/lote-faturamentos/:loteFaturamento/edit',
        name: 'LoteFaturamentosEdit',
        component: () => import('../views/lote_faturamentos/LoteFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'edit',
        },
      },
      {
        path: '/app/lote-faturamentos/:loteFaturamento',
        name: 'LoteFaturamentosShow',
        component: () => import('../views/lote_faturamentos/LoteFaturamentosPage.vue'),
        meta: {
          middleware: Auth,
          mode: 'show',
        },
      },
      {
        path: '/app/suprimentos',
        name: 'SuprimentosIndex',
        component: () => import(/* webpackChunkName: "SuprimentosIndex" */ '../views/suprimentos/SuprimentosIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/suprimentos/create',
        name: 'SuprimentosCreate',
        component: () => import(/* webpackChunkName: "SuprimentosCreate" */ '../views/suprimentos/SuprimentosCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/suprimentos/:suprimento/edit',
        name: 'SuprimentosEdit',
        component: () => import(/* webpackChunkName: "SuprimentosEdit" */ '../views/suprimentos/SuprimentosEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/suprimentos/:suprimento',
        name: 'SuprimentosShow',
        component: () => import(/* webpackChunkName: "SuprimentosShow" */ '../views/suprimentos/SuprimentosShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/medicamentos',
        name: 'MedicamentosIndex',
        component: () => import('../views/medicamentos/MedicamentosIndex.vue'),
        meta: { middleware: Auth },
      },
      {
        path: '/app/medicamentos/create',
        name: 'MedicamentosCreate',
        component: () => import('../views/medicamentos/MedicamentosPage.vue'),
        meta: { middleware: Auth, mode: 'create' },
      },
      {
        path: '/app/medicamentos/:medicamento/edit',
        name: 'MedicamentosEdit',
        component: () => import('../views/medicamentos/MedicamentosPage.vue'),
        meta: { middleware: Auth, mode: 'edit' },
      },
      {
        path: '/app/equipamentos',
        name: 'EquipamentosIndex',
        component: () => import(/* webpackChunkName: "EquipamentosIndex" */ '../views/equipamentos/EquipamentosIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/equipamentos/create',
        name: 'EquipamentosCreate',
        component: () => import(/* webpackChunkName: "EquipamentosCreate" */ '../views/equipamentos/EquipamentosCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/equipamentos/:equipamento/edit',
        name: 'EquipamentosEdit',
        component: () => import(/* webpackChunkName: "EquipamentosEdit" */ '../views/equipamentos/EquipamentosEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/equipamentos/:equipamento',
        name: 'EquipamentosShow',
        component: () => import(/* webpackChunkName: "EquipamentosShow" */ '../views/equipamentos/EquipamentosShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/fornecedores',
        name: 'FornecedoresIndex',
        component: () => import(/* webpackChunkName: "FornecedoresIndex" */ '../views/fornecedores/FornecedoresIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/fornecedores/create',
        name: 'FornecedoresCreate',
        component: () => import(/* webpackChunkName: "FornecedoresCreate" */ '../views/fornecedores/FornecedoresCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/fornecedores/:fornecedor/edit',
        name: 'FornecedoresEdit',
        component: () => import(/* webpackChunkName: "FornecedoresEdit" */ '../views/fornecedores/FornecedoresEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/fornecedores/:fornecedor',
        name: 'FornecedoresShow',
        component: () => import(/* webpackChunkName: "FornecedoresShow" */ '../views/fornecedores/FornecedoresShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/profissionais',
        name: 'ProfissionaisIndex',
        component: () => import(/* webpackChunkName: "ProfissionaisIndex" */ '../views/profissionais/ProfissionaisIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/profissionais/create',
        name: 'ProfissionaisCreate',
        component: () => import(/* webpackChunkName: "ProfissionaisCreate" */ '../views/profissionais/ProfissionaisCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/profissionais/:profissional/dashboard',
        name: 'ProfissionaisDashboard',
        component: () => import(/* webpackChunkName: "Home" */ '../views/home/Index.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/profissionais/:profissional/edit',
        name: 'ProfissionaisEdit',
        component: () => import(/* webpackChunkName: "ProfissionaisEdit" */ '../views/profissionais/ProfissionaisEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/profissionais/:profissional',
        name: 'ProfissionaisShow',
        component: () => import(/* webpackChunkName: "ProfissionaisShow" */ '../views/profissionais/ProfissionaisShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/tipo-profissionais',
        name: 'TipoProfissionaisIndex',
        component: () => import(/* webpackChunkName: "TipoProfissionaisIndex" */ '../views/tipo-profissionais/TipoProfissionaisIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/tipo-profissionais/create',
        name: 'TipoProfissionaisCreate',
        component: () => import(/* webpackChunkName: "TipoProfissionaisCreate" */ '../views/tipo-profissionais/TipoProfissionaisCreate.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/tipo-profissionais/:tipoProfissional/edit',
        name: 'TipoProfissionaisEdit',
        component: () => import(/* webpackChunkName: "TipoProfissionaisEdit" */ '../views/tipo-profissionais/TipoProfissionaisEdit.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/tipo-profissionais/:tipoProfissional',
        name: 'TipoProfissionaisShow',
        component: () => import(/* webpackChunkName: "TipoProfissionaisShow" */ '../views/tipo-profissionais/TipoProfissionaisShow.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/conselho-profissionais',
        name: 'ConselhoProfissionaisIndex',
        component: () => import(/* webpackChunkName: "ConselhoProfissionaisIndex" */ '../views/conselho-profissionais/ConselhoProfissionaisIndex.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/conselho-profissionais/create',
        name: 'ConselhoProfissionaisCreate',
        component: () => import(/* webpackChunkName: "ConselhoProfissionaisCreate" */ '../views/conselho-profissionais/ConselhoProfissionaisCreate.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/conselho-profissionais/:conselhoProfissional/edit',
        name: 'ConselhoProfissionaisEdit',
        component: () => import(/* webpackChunkName: "ConselhoProfissionaisEdit" */ '../views/conselho-profissionais/ConselhoProfissionaisEdit.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/conselho-profissionais/:conselhoProfissional',
        name: 'ConselhoProfissionaisShow',
        component: () => import(/* webpackChunkName: "ConselhoProfissionaisShow" */ '../views/conselho-profissionais/ConselhoProfissionaisShow.vue'),
        meta: {
          middleware: Auth,
        },
      },
      {
        path: '/app/prestadores',
        name: 'PrestadoresIndex',
        component: () => import(/* webpackChunkName: "PrestadoresIndex" */ '../views/prestadores/PrestadoresIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/prestadores/:prestador/edit',
        name: 'PrestadoresEdit',
        component: () => import(/* webpackChunkName: "PrestadoresEdit" */ '../views/prestadores/PrestadoresEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/prestadores/:prestador',
        name: 'PrestadoresShow',
        component: () => import(/* webpackChunkName: "PrestadoresShow" */ '../views/prestadores/PrestadoresShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      //ADMIN
      {
        path: '/app/usuarios',
        name: 'UsuariosIndex',
        component: () => import(/* webpackChunkName: "UsuariosIndex" */ '../views/usuarios/UsuariosIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/usuarios/create',
        name: 'UsuariosCreate',
        component: () => import(/* webpackChunkName: "UsuariosCreate" */ '../views/usuarios/UsuariosCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/usuarios/:user/edit',
        name: 'UsuariosEdit',
        component: () => import(/* webpackChunkName: "UsuariosEdit" */ '../views/usuarios/UsuariosEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/usuarios/:user',
        name: 'UsuariosShow',
        component: () => import(/* webpackChunkName: "UsuariosShow" */ '../views/usuarios/UsuariosShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/roles',
        name: 'RolesIndex',
        component: () => import(/* webpackChunkName: "RolesIndex" */ '../views/roles/RolesIndex.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/roles/create',
        name: 'RolesCreate',
        component: () => import(/* webpackChunkName: "RolesCreate" */ '../views/roles/RolesCreate.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/roles/:role/edit',
        name: 'RolesEdit',
        component: () => import(/* webpackChunkName: "RolesEdit" */ '../views/roles/RolesEdit.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: '/app/roles/:role',
        name: 'RolesShow',
        component: () => import(/* webpackChunkName: "RolesShow" */ '../views/roles/RolesShow.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      //
      {
        path: '/app/unauthorized',
        name: 'Unauthorized',
        component: () => import(/* webpackChunkName: "Unauthorized" */ '../views/auth/Unauthorized.vue'),
        meta: { 
          middleware: Auth,
        },
      },
      {
        path: "*",
        component: () => import("@/views/NotFound.vue"),
        meta: { 
          middleware: Auth,
        },
      }
    ]
  },
  {
    path: "*",
    name: "Notfound",
    component: () => import("@/views/NotFound.vue")
  }
]

const router = new VueRouter({
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  mode: 'history',
  base: '/',
  routes
})

router.beforeEach(async (to, from, next) => {
  if(!to.meta.middleware) {
    return next();
  }

  const middleware = to.meta.middleware;
  const context = {
    to,
    from,
    next,
    store
  };

  return middleware({
    ...context
  });
});

export default router
